<template>
  <ul class="timeline">
    <li class="timeline-item" v-for="group in groups" :key="group.key" :class="group.type">
      <div class="timeline-item__tail"></div>
      <div class="timeline-item__node timeline-item__node--normal">
        <!---->
      </div>
      <!---->
      <div class="timeline-item__wrapper">
        <div class="timeline-item__timestamp is-top">{{group.title}}</div>
        <div class="timeline-item__content">
          <div class="timeline-card">
            <!---->
            <div class="timeline-card__body">
              <template v-if="group.items.length>1">
                <ul class="timeline">
                  <li class="timeline-item" v-for="item in group.items" :key="item.key" :class="item.type">
                    <div class="timeline-item__tail"></div>
                    <div class="timeline-item__node timeline-item__node--normal"></div>
                    <div class="timeline-item__wrapper">
                      <div class="timeline-item__content">
                        <span class="timeline-text-left">{{item.operator}} <call-mobile :account-id="item.operatorId"></call-mobile></span>
                        <span class="timeline-text-right">{{item.operation}}</span>
                      </div>
                      <div class="el-timeline-item__timestamp is-bottom">
                        <p v-if="item.time">{{item.time}}</p>
                        <p v-if="item.comment">{{item.comment}}</p>
                        <p v-if="item.remark">{{item.remark}}</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </template>
              <template v-if="group.items.length==1">
                <div v-for="item in group.items" :key="item.key" :class="item.type">
                  <span class="timeline-text-left">{{item.operator}} <call-mobile :account-id="item.operatorId"></call-mobile></span>
                  <span class="timeline-text-right">{{item.operation}}</span>
                  <p v-if="item.time">{{item.time}}</p>
                  <p v-if="item.comment">{{item.comment}}</p>
                  <p v-if="item.remark">{{item.remark}}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
        <!---->
      </div>
    </li>
  </ul>
</template>

<script>
import CallMobile from "@/components/button/CallMobile.vue";

export default {
  props: {
    groups: Array
  },
  components: {
    CallMobile
  }
};
</script>

<style scoped>
.timeline {
  margin: 0;
  font-size: 14px;
  list-style: none;
}
.timeline-item {
  position: relative;
  padding-bottom: 20px;
}
.timeline-item__tail {
  position: absolute;
  left: 4px;
  height: 100%;
  border-left: 2px solid #e4e7ed;
}
.timeline-item__node {
  position: absolute;
  background-color: #e4e7ed;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.timeline-item__node--normal {
  left: -1px;
  width: 12px;
  height: 12px;
}
.timeline-item__wrapper {
  position: relative;
  padding-left: 28px;
  top: -3px;
}
.timeline-item__timestamp {
  color: #909399;
  line-height: 1;
  font-size: 13px;
}
.timeline-item__timestamp.is-top {
  margin-bottom: 8px;
  padding-top: 4px;
}
.timeline-item__content {
  /* color: #303133; */
  color: var(--weui-FG-0);
}
.timeline-card {
  border-radius: 4px;
  border: 1px solid #ebeef5;
  /* background-color: #fff; */
  background-color: var(--weui-BG-2);
  overflow: hidden;
  /* color: #303133; */
  color: var(--weui-FG-0);
  transition: 0.3s;
}
.timeline-card__body {
  padding: 20px;
}
.timeline-card__body p {
  font-size: 13px;
  color: #5e6d82;
  line-height: 1.5em;
}
.timeline-text-left .iconfont {
  line-height: 1;
  font-size: 16px;
  margin-left: 10px;
  color: #07c160;
}
.timeline-text-right {
  float: right;
  color: #909399;
}

.error .timeline-item__tail{
    border-color: #e44959
}
.error .timeline-item__node {
    background-color: #e44959
}
.error .timeline-text-right {
    color: #e44959
}

.warning .timeline-item__tail{
    border-color: #ffc107
}
.warning .timeline-item__node {
    background-color: #ffc107
}
.warning .timeline-text-right {
    color: #ffc107
}

.success .timeline-item__tail{
    border-color: #07c160
}
.success .timeline-item__node {
    background-color: #07c160
}
.success .timeline-text-right {
    color: #07c160
}
</style>